      import styled from 'styled-components';

const lightPatternBackground = `
  background-color: #E9EAF3;
`;

export const CenteringWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 100vh;
${lightPatternBackground}

`;

export const Container = styled.div`
background-color: #fff;
border-radius: 10px;
box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
position: relative;
overflow: hidden;
width: 90%; /* Adjust width for smaller screens */
height: 90%; /* Adjust height for smaller screens */
max-width: 678px;
max-height: 550px;

  // Media query for screens smaller than 719x921
  @media (max-width: 719px) and (max-height: 921px) {
    width: 80%;
    max-width: 100%;
    height: 70%;
    max-height: 100%;
  }
`;

export const SignUpContainer = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  font-size: 15px; /* Adjust font size for smaller screens */
  transition: all 0.6s ease-in-out;
  left: 0;
  width: 50%;
  opacity: 0;
  z-index: 1;
  ${props => !props.signinIn && `
    transform: translateX(100%);
    opacity: 1;
    z-index: 5;
  `};

  @media (max-width: 719px) {
    font-size: 14px; /* Adjust font size further for screens smaller than 719px */
  }
`;


export const SignInContainer = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  font-size: 15px; /* Adjust font size for smaller screens */
  transition: all 0.6s ease-in-out;
  left: 0;
  width: 50%;
  z-index: 2;
  ${props => !props.signinIn && `
    transform: translateX(100%);
  `};
  @media (max-width: 719px) {
    font-size: 14px; /* Adjust font size further for screens smaller than 719px */
  }
`;

export const Form = styled.form`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 20px; /* Adjust padding for smaller screens */
  height: 100%;
  text-align: center;
`;

export const Title = styled.h1`
  font-weight: bold;
  margin: 10px 0;
`;

export const Input = styled.input`
  background-color: #eee;
  border: none;
  padding: 8px 12px;
  margin: 4px 0;
  width: 90%;
`;

export const Button = styled.button`
border-radius: 15px;
margin: 10px 0;
border: 1px solid #6415ff;
background-color: #6415ff;
color: #ffffff;
font-size: 10px;
font-weight: bold;
padding: 10px 20px; /* Adjust padding for smaller screens */
letter-spacing: 1px;
text-transform: uppercase;
transition: transform 80ms ease-in;
&:active {
  transform: scale(0.95);
}
&:focus {
  outline: none;
}
`;

export const GhostButton = styled(Button)`
background-color: transparent;
border-color: #fff;
`;

export const Anchor = styled.a`
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
  ${props => !props.signinIn && `
    transform: translateX(-100%);
  `};
`;

export const Overlay = styled.div`
background: #6415ff;
background: -webkit-linear-gradient(to right, #2a348f, #6415ff); 
background: linear-gradient(to right, #2a348f, #6415ff); 

  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  color: #ffffff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  ${props => !props.signinIn && `
    transform: translateX(50%);
  `};
`;

export const OverlayPanel = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 20px; /* Adjust padding for smaller screens */
  text-align: center;
  top: 0;
  height: 100%;
  width: 50%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
`;

export const LeftOverlayPanel = styled(OverlayPanel)`
  transform: translateX(-20%);
  ${props => !props.signinIn && `
    transform: translateX(0);
  `};
`;

export const RightOverlayPanel = styled(OverlayPanel)`
  right: 0;
  transform: translateX(0);
  ${props => !props.signinIn && `
    transform: translateX(20%);
  `};
`;

export const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;
`;

export const FullPageOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 1000; // Ensure it's above other elements
`;